export const isAuthenticated = () => {
  
let autorizacao = localStorage.getItem('@VersaB2B:Autorizacao');  

if(autorizacao == "true"){
  return true;
}else{
  return false;
}
};